import { render, staticRenderFns } from "./tel-recover-case-manage.vue?vue&type=template&id=4ff22c76&scoped=true"
import script from "./tel-recover-case-manage.vue?vue&type=script&lang=ts"
export * from "./tel-recover-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff22c76",
  null
  
)

export default component.exports